class Badges {
  constructor() {
    this.data = {};
  }

  set(data) {
    this.data = JSON.parse(data);
  }

  get() {
    return this.data;
  }
}

export default new Badges();



// WEBPACK FOOTER //
// ./src/requests/apa/Badges.js